<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Budget Release Info
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-3">
                <v-row>

                  <!-- Department -->
                  <v-col cols="12">
                    <v-autocomplete
                      label="Department"
                      v-model="department_id"
                      :items="getHrmDepartmentList"
                      item-title="name"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.department_id"
                      hide-details
                    />
                  </v-col>

                  <!-- Financial Year -->
                  <v-col cols="12">

                    <v-autocomplete
                      label="Financial Year"
                      v-model="financial_year"
                      :items="getFinancialYearList()"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.financial_year"
                      hide-details
                    />
                  </v-col>

                  <!-- Release Date -->
                  <v-col cols="12">
                    <v-date-input
                      label="Release Date"
                      v-model="release_date"
                      density="compact"
                      variant="outlined"
                      prepend-icon=""
                      clearable
                      :error-messages="errors.release_date"
                      hide-details
                    />
                  </v-col>

                  <!-- Description -->
                  <v-col cols="12">
                    <v-textarea
                      label="Description"
                      v-model="description"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.description"
                      hide-details
                      rows="2"
                    />
                  </v-col>

                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Budget Release Details
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-3">
                <v-row>

                  <v-col cols="12">
                    <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="height: 40vh; overflow-y: auto; width: 100%;"
                    >
                      <thead>
                        <tr>
                          <th style="width:200px;">Type</th>
                          <th style="width:250px;">Head</th>
                          <th style="width: 300px;">Sub Head</th>
                          <th style="width: 150px;">Amount</th>
                          <th style="width:100px;">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in cart" :key="index">
                          <td>

                            <v-autocomplete
                                v-model="item.budget_type_id"
                                :items="budgetTypeList"
                                item-title="name"
                                item-value="id"
                                density="compact"
                                variant="outlined"
                                :error-messages="errors[`cart_${index}_budget_type`]"
                                @update:modelValue="val => changeBudgetType(val, index)"
                                clearable
                                hide-details
                            />

                            
                        </td>
                        <td>

                            <v-autocomplete
                                v-model="item.budget_head_id"
                                :items="getFilteredHeads(item)"
                                item-title="name"
                                item-value="id"
                                density="compact"
                                variant="outlined"
                                :error-messages="errors[`cart_${index}_budget_head`]"
                                @update:modelValue="val => changeBudgetHead(val, index)"
                                clearable
                                hide-details
                            />

                        </td>
                        <td>
                            <v-autocomplete
                                v-model="item.budget_sub_head_id"
                                :items="getFilteredSubHeads(item)"
                                item-title="name"
                                item-value="id"
                                density="compact"
                                variant="outlined"
                                :error-messages="errors[`cart_${index}_sub_head`]"
                                @update:modelValue="val => onChangeBudgetSubHead(val, index)"
                                clearable
                                hide-details
                            />

                          </td>
                          <td>
                            <v-text-field
                                style="width: 100% !important;"
                                v-model="item.amount"
                                type="number"
                                density="compact"
                                variant="outlined"
                                hide-details
                                 :error-messages="errors[`cart_${index}_amount`]"
                            />
                          </td>
                          <td>
                            <v-btn v-if="(index != cart.length - 1) || (cart.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeCartItem(index)">
                                <v-icon color="red">mdi-close</v-icon>
                            </v-btn>

                              <v-btn v-if="index == cart.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addCartItem">
                                <v-icon color="blue">mdi-plus</v-icon>
                              </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>

                  <!-- Status Buttons -->
                  <v-col cols="12" class="d-flex justify-end mt-4">
                    <v-btn
                      class="bg-grey-darken-1 me-2"
                      variant="flat"
                      :loading="loading"
                      @click="submitBudget(0)"
                    >
                      Draft
                    </v-btn>

                    <v-btn
                      class="bg-primary"
                      variant="flat"
                      :loading="loading"
                      @click="submitBudget(1)"
                    >
                      {{ isEdit ? "Update" : "Save" }}
                    </v-btn>
                  </v-col>

                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useRouter, useRoute } from "vue-router";

const store = useStore();
const router = useRouter();
const route = useRoute();

const panel = ref([0]);
const panel1 = ref([0]);
const isEdit = ref(false);
const loading = ref(false);
const budgetId = ref(null);

/* ================= FORM ================= */
const department_id = ref(null);
const financial_year = ref(null);
const release_date = ref(null);
const description = ref("");
const cart = ref([]);
/* ================= VALIDATION ================= */
const errors = ref({});
/* ================= STATIC ================= */
const statusList = [
  { title: "Draft", value: 0 },
  { title: "Published", value: 1 },
];

/* ================= GETTERS ================= */
const getHrmDepartmentList = computed(() => store.getters.getHrmDepartmentList || []);
const budgetTypeList = computed(() => store.getters.getBudgetTypeList || []);
const budgetHeadList = computed(() => store.getters.getBudgetHeadList || []);
const subHeadList = computed(() => store.getters.getBudgetSubHeadList || []);
function getFinancialYearList() {
  const currentYear = new Date().getFullYear() - 1;
  const numberOfYears = 1; // pichoner 10 bochhor
  let years = [];
  for (let i = 0; i <= numberOfYears; i++) {
    const startYear = currentYear + i;
    years.push(`${startYear}`);
  }
  return years;
}

function getFilteredHeads(item) {
  return budgetHeadList.value.filter(
    (head) => head.budget_type_id == item.budget_type_id
  );
}

function getFilteredSubHeads(item) {
  return subHeadList.value.filter(
    (sub) => sub.budget_head_id == item.budget_head_id
  );
}

/* ================= METHODS ================= */

function changeBudgetType(value, index) {
  cart.value[index].budget_head_id = null;
  cart.value[index].budget_sub_head_id = null;

  // optional: error clear
  delete errors.value[`cart_${index}_budget_head`];
  delete errors.value[`cart_${index}_sub_head`];
}

function changeBudgetHead(value, index) {
  cart.value[index].budget_sub_head_id = null;

  // optional: error clear
  delete errors.value[`cart_${index}_sub_head`];
}

const onChangeBudgetSubHead = (value, index) => {
  const exists = cart.value.some(
    (item, i) =>
      item.budget_sub_head_id === value && i !== index
  );
  if (exists) {
    toast.error("This item already selected!");
    cart.value[index].budget_sub_head_id = null;
  } else {
    cart.value[index].budget_sub_head_id = value;
  }
};

const addCartItem = () => {
  cart.value.push({ budget_sub_head_id: null, amount: null });
};

const removeCartItem = (index) => {
  cart.value.splice(index, 1);
};

const validate = () => {
  errors.value = {};
  if (!department_id.value) errors.value.department_id = ["Required"];
  if (!financial_year.value) errors.value.financial_year = ["Required"];
  if (!release_date.value) errors.value.release_date = ["Required"];
  if (!description.value) errors.value.description = ["Required"];
  if (!cart.value.length) errors.value.cart = ["At least 1 budget item is required"];
  cart.value.forEach((item, idx) => {
    if (!item.budget_type_id) errors.value[`cart_${idx}_budget_type`] = ["Required"];
    if (!item.budget_head_id) errors.value[`cart_${idx}_budget_head`] = ["Required"];
    if (!item.budget_sub_head_id) errors.value[`cart_${idx}_sub_head`] = ["Required"];
    if (!item.amount) errors.value[`cart_${idx}_amount`] = ["Required"];
  });
  return Object.keys(errors.value).length === 0;
};

const submitBudget = async (statusValue) => {
  if (!validate()) return;
  loading.value = true;

  const payload = {
    id: isEdit.value ? budgetId.value : null,
    department_id: department_id.value,
    financial_year: financial_year.value,
    release_date: release_date.value,
    description: description.value,
    status: statusValue,
    cart: cart.value,
  };

  try {
    if (isEdit.value) {
      await store.dispatch("updateBudgetRelease", payload);
      toast.success("Budget release updated successfully");
    } else {
      await store.dispatch("saveBudgetRelease", payload);
      toast.success("Budget release saved successfully");
    }
    router.push({ name: "budget-release-records" });
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong!");
  } finally {
    loading.value = false;
  }
};

const loadData = async () => {
  await store.dispatch("getHrmDepartmentList");
  await store.dispatch("getBudgetTypeList");
  await store.dispatch("getBudgetHeadList");
  await store.dispatch("getBudgetSubHeadList");
};

const loadBudget = async (id) => {
  try {
    const res = await store.dispatch("getBudgetReleaseById", id);
    const data = res.data;
    department_id.value = data.department_id;
    financial_year.value = data.financial_year;
    release_date.value = data.release_date;
    description.value = data.description;
    cart.value = data.details.map(d => ({
        budget_type_id: d.budget_sub_head?.budget_head?.budget_type?.id || null,
        budget_head_id: d.budget_sub_head?.budget_head?.id || null,
        budget_sub_head_id: d.budget_sub_head?.id || null,
        amount: d.amount || null,
    }));
  } catch (e) {
    toast.error("Failed to load budget release");
  }
};

onMounted(async () => {
    cart.value.push({
        budget_type_id: null,
        budget_head_id: null,
        budget_sub_head_id: null,
        amount: null
    });
    loading.value = true;
    await loadData();
    if (route.query.id) {
        isEdit.value = true;
        budgetId.value = route.query.id;
        await loadBudget(budgetId.value);
    }
    loading.value = false;
});
</script>